import { createSelector } from 'reselect';
import {
  CURRENT_PAGE_TYPE,
  DESTINATION_CITY,
  ORIGIN_CITY,
  TRIP_DATA,
} from './constants';
import {
  formatSpecificTableData,
  formatSpecificTableHeaders,
} from './helpers/tableHelpers';
import { initialState } from './reducer';

const selectSearchDomain = (state) => state.get('search', initialState);

/**
 * @description Memoized selector to retrieve specific table headers (transport means)
 * @returns {*}
 */
const selectSpecificTableHeaders = () =>
  createSelector(selectSearchDomain, (searchState) => {
    const state = searchState.toJS();
    const tripData = state[TRIP_DATA];
    const originCity = state[ORIGIN_CITY];
    const destinationCity = state[DESTINATION_CITY];
    const currentPageType = state[CURRENT_PAGE_TYPE];

    return formatSpecificTableHeaders(
      tripData,
      originCity,
      destinationCity,
      currentPageType,
    );
  });

/**
 * @description Memoized selector to retrieve specific table data
 * @returns {*}
 */
const selectSpecificTableData = () =>
  createSelector(selectSearchDomain, (searchState) => {
    const state = searchState.toJS();
    const tripData = state[TRIP_DATA];
    const originCity = state[ORIGIN_CITY];
    const destinationCity = state[DESTINATION_CITY];
    const currentPageType = state[CURRENT_PAGE_TYPE];

    return formatSpecificTableData(
      tripData,
      originCity,
      destinationCity,
      currentPageType,
    );
  });

const makeSelectSearch = () =>
  createSelector(selectSearchDomain, (substate) => substate.toJS());

export default makeSelectSearch;
export {
  selectSearchDomain,
  selectSpecificTableData,
  selectSpecificTableHeaders,
};
